var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p'),_c('h2',[_vm._v(" 初始化之前会重置全部数据哦,注意注意,咳 但是你看到这里其实已经点了已经没有办法了 ")]),_c('h2',[_vm._v(" 初始化设备状态, 显示创建结果 init_device \"; ")]),_c('h2',[_vm._v(" 12月25日 新设计 init device ")]),_c('p')])
}]

export { render, staticRenderFns }